import script from "./ModalContentComponent.vue?vue&type=script&lang=js"
export * from "./ModalContentComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__